var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"justify-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('cpn-lead-form'),_c('cpnLeadEconomy',{attrs:{"lead":_vm.lead}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }